import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { IntlProvider } from 'react-intl';

import { LoadStepComponent as LoadStep } from './LoadStepComponent';
import { CustomCssWrapperComponent as CustomCssWrapper } from './CustomCssWrapperComponent';
import { CustomTextWrapper } from './CustomTextWrapper';
import { TestModeFlagComponent } from './TestModeFlag/TestModeFlagComponent';

export const NewVerificationInnerComponent = ({ locale, messages, programTheme, verificationService }) => {
    return (
        // Don't change locale, so we don't have to load pluralization data, which has complications. HD-560
        <IntlProvider locale={'en'} key={locale} messages={messages} textComponent={CustomTextWrapper}>
            <CustomCssWrapper styles={programTheme.customCss}>
                <TestModeFlagComponent verificationService={verificationService} />
                <LoadStep stepToLoad={verificationService.verificationResponse.currentStep} verificationService={verificationService} />
            </CustomCssWrapper>
        </IntlProvider>
    );
};
